import { render, staticRenderFns } from "./CoverYearCCRGroup.vue?vue&type=template&id=1cce0177"
import script from "./CoverYearCCRGroup.vue?vue&type=script&lang=js"
export * from "./CoverYearCCRGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports